// src/components/common/Header.js
import React, { useState } from "react";
import { Menu, X } from "lucide-react";
import { navigation } from "../../data";

const Header = ({ goToSection, currentSection }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (index) => {
    goToSection(index);
    setIsMenuOpen(false);
  };

  // Determinar la sección activa por ID
  const sections = navigation.map((item) => item.id);
  const activeSection = sections[currentSection] || "home";

  // Determinar si usar texto claro u oscuro basado en la sección activa
  const isOnDarkSection = activeSection === "home" || activeSection === "about" || activeSection === "projects";
  const textColorClass = isOnDarkSection
    ? "text-white"
    : "text-gray-900";
  const textColorActiveClass = isOnDarkSection
    ? "text-white"
    : "text-gray-900";
  const textColorInactiveClass = isOnDarkSection
    ? "text-white/70 hover:text-white"
    : "text-gray-400 hover:text-gray-700";
  const backdropClass = isOnDarkSection
    ? "bg-transparent"
    : "bg-white/80 backdrop-blur-md border-b border-gray-100";

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${backdropClass}`}>
      {/* Sombra sutil para legibilidad sobre imágenes - aplicado a todas las secciones oscuras */}
      {isOnDarkSection && (
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/10 to-transparent pointer-events-none"></div>
      )}

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex justify-center items-center py-6">
          {/* Desktop Menu - Centrado */}
          <div className="hidden md:flex space-x-12">
            {navigation.map((item, index) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(index)}
                className={`text-xs uppercase tracking-widest transition-all duration-300 font-light drop-shadow-md relative pb-1 ${
                  activeSection === item.id
                    ? textColorActiveClass
                    : textColorInactiveClass
                }`}
                style={{
                  opacity: activeSection === item.id ? 1 : 0.8
                }}
              >
                {item.label}
                {/* Subrayado para sección activa */}
                {activeSection === item.id && (
                  <span
                    className="absolute bottom-0 left-0 w-full h-[1px] transition-all duration-300"
                    style={{ backgroundColor: 'currentColor' }}
                  ></span>
                )}
              </button>
            ))}
          </div>

          {/* Espacio vacío para balance en mobile */}
          <div className="md:hidden"></div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className={`md:hidden p-2 transition-colors drop-shadow-lg ${textColorClass}`}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={20} strokeWidth={1.5} /> : <Menu size={20} strokeWidth={1.5} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className={`md:hidden py-6 backdrop-blur-xl ${isOnDarkSection ? 'bg-black/50' : 'bg-white/95 border-t border-gray-100'}`}>
            {navigation.map((item, index) => (
              <button
                key={item.id}
                onClick={() => handleNavClick(index)}
                className={`block w-full text-center py-4 text-xs uppercase tracking-widest transition-colors font-light ${
                  activeSection === item.id
                    ? textColorActiveClass
                    : textColorInactiveClass
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Header;
